import { render, staticRenderFns } from "./SucursalProductosHome.vue?vue&type=template&id=3d7c0600&scoped=true&"
import script from "./SucursalProductosHome.vue?vue&type=script&lang=js&"
export * from "./SucursalProductosHome.vue?vue&type=script&lang=js&"
import style0 from "./SucursalProductosHome.vue?vue&type=style&index=0&id=3d7c0600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c0600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VDivider,VFadeTransition,VRow,VTab,VTabs})
